"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _createSvgIcon = _interopRequireDefault(require("../utils/createSvgIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = (0, _createSvgIcon["default"])( /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M17.83,16.45A1.48,1.48,0,0,0,18.88,16l3-3-.92-.92-2.46,2.46V3.88h-1.3v10.7l-2.46-2.46L13.8,13l3,3A1.48,1.48,0,0,0,17.83,16.45Z"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M27.54,8.17H22.47v1.3h4.42V21.94H9.69L6.26,9.47h7V8.17H5.9L4.7,3.8l-1.26.35L8.57,22.77a.63.63,0,0,0,.62.47H27.54a.65.65,0,0,0,.65-.65V8.82A.65.65,0,0,0,27.54,8.17Z"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M11.53,24.82a1.65,1.65,0,1,0,1.65,1.65A1.65,1.65,0,0,0,11.53,24.82Z"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M26.28,24.82a1.65,1.65,0,1,0,1.65,1.65A1.65,1.65,0,0,0,26.28,24.82Z"
}))));
module.exports = exports.default;